<template>
    <q-dialog :model-value="modalShown">
        <q-card
            class="dialog"
            transition-show="fade"
            :style="style"
        >
            <slot name="header" />
            <slot name="content" />
            <slot name="footer" />
        </q-card>
    </q-dialog>
</template>

<script setup>

defineProps({
    modalShown: Boolean,
    style: {
        type: Object,
        default: () => {
            return {
                width: 'auto',
                maxWidth: '80vw',
            }
        },
    },
})
</script>
